export default {
  SET_BRANCHES(state, branches) {
    state.branches = branches;
  },
};
